/**
 * @fileoverview POST handler for the "/:app_group_id/canvas/:workflow_id/step" endpoint
 */
import { stepClassKey } from "@lib/canvas/type-safe-configs";
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../../reactQueryFetcherAdapters";
import { appGroupIdCanvasWorkflowIdStepCacheKeys } from "./constants";
import type { PostAppGroupIdCanvasWorkflowIdStepProps, PostCanvasStepResult } from "./types";

export const postCanvasStep = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepCacheKeys,
  ({
    appGroupId,
    workflowId,
    stepData,
    type,
    ...rest
  }: PostAppGroupIdCanvasWorkflowIdStepProps): Promise<PostCanvasStepResult> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step`,
      "POST",
      {
        ...rest,
        type: stepClassKey[type],
        step_data: stepData,
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
